import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { useI18n } from '@/helpers/composables/useI18n';

import { SportEventStatus } from '@/@types/graphql-types';
import { captureMessageForSentry } from '@/helpers/sentry-helper';

/* TRANSLATIONS */
interface GameEventStatusProps {
	eventStatus: SportEventStatus;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'GameEventStatus',
  props: {
    eventStatus: null
  },
  setup(__props: any) {

const props = __props as {
	eventStatus: SportEventStatus;
};

const { t } = useI18n();



const isLive = computed(() => props.eventStatus === SportEventStatus.Live);

const gameStatusContent = computed(() => {
	switch (props.eventStatus) {
		case SportEventStatus.Live:
			return t('SPORTS_WEBAPP_LIVE');
		case SportEventStatus.Started:
			return t('SPORTS_WEBAPP_STARTED');
		case SportEventStatus.Ended:
		case SportEventStatus.Closed:
			return t('SPORTS_WEBAPP_ENDED');
		case SportEventStatus.Suspended:
			return t('SPORTS_WEBAPP_SUSPENDED');
		case SportEventStatus.Interrupted:
			return t('SPORTS_WEBAPP_INTERRUPTED');
		case SportEventStatus.Delayed:
			return t('SPORTS_WEBAPP_DELAYED');
		case SportEventStatus.Postponed:
			return t('SPORTS_WEBAPP_POSTPONED');
		case SportEventStatus.Cancelled:
			return t('SPORTS_WEBAPP_CANCELLED');
		default:
			captureMessageForSentry(
				'[Cannot set gameStatusContent text]:',
				{
					error: new Error(`${props.eventStatus} is not a valid event status.`),
					where: '[components/sport/common/chip/GameEventStatus.vue] gameStatusContent()',
				},
				'error'
			);

			return '';
	}
});

return { __sfc: true,t, props, isLive, gameStatusContent }
}

})